module.exports = __webpack_public_path__ + "static/media/7.b3e3e748.jpg";